module.exports = __webpack_public_path__ + "static/seo-3e6493746ed2789bf1810f8332908af0.jpg";